import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery, transformErrorResponse, transformErrorResponseWithMessage, transformResponse } from "../../baseQuery";

export const IndividualSubjectApiSlice = createApi({
    reducerPath: "IndividualSubjectApiSlice",
    baseQuery,

    tagTypes: ["individualSubject", "getSubjectTopUniversitiesApi", "getScholarshipsubject"],

    endpoints: (builder) => ({

        getIndividualSubjectApi: builder.query({
            query: (id) => ({
                url: `studyAbroadCourse/user/${id}`,
                method: "GET",
            }),
            transformResponse,
            transformErrorResponse: transformErrorResponseWithMessage,
            providesTags: ["individualSubject"]
        }),


        getSubjectTopUniversitiesApi: builder.query({
            query: ({
                subjectId, courseID, page = 1, limit = 3
            }) => ({
                url: `studyAbroadCourse/usertopUniversitysubjectpagination`,
                method: "GET",
                params: { subjectId, courseId: courseID, page, limit }
            }),
            transformResponse,
            transformErrorResponse: transformErrorResponseWithMessage,
            providesTags: ["getSubjectTopUniversitiesApi"]
        }),

        getScholarshipsubjectApi: builder.query({
            query: ({
                subjectId, courseID, page = 1, limit = 3
            }) => ({
                url: `studyAbroadCourse/userscholarshipsubjectPagination`,
                method: "GET",
                params: { subjectId, courseId: courseID, page, limit }
            }),
            transformResponse,
            transformErrorResponse: transformErrorResponseWithMessage,
            providesTags: ["getScholarshipsubject"]
        }),


    }),
});

export const {
    useGetIndividualSubjectApiQuery,
    useGetSubjectTopUniversitiesApiQuery,
    useGetScholarshipsubjectApiQuery
} = IndividualSubjectApiSlice; 